import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=e6d7c990&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=e6d7c990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d7c990",
  null
  
)

export default component.exports